import { createTheme } from '@mui/material/styles';

const appTheme = createTheme({
  palette: {
    primary: {
      main: '#004cab',
    },
    secondary: {
      main: '#73bcff',
    },
    // mode: 'dark',
  },
  typography: {
    fontFamily: 'Source Sans Pro,sans-serif',
  },
});

export { appTheme };
